import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-plus-simple",
  "use": "app-icon-plus-simple-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"app-icon-plus-simple\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h64v64H0z\" /><path d=\"M34 8a2 2 0 012 2v22h22a2 2 0 110 4H36v22a2 2 0 11-4 0V36H10a2 2 0 110-4h22V10a2 2 0 012-2z\" fill=\"gray\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol